import { dayjs, tz } from '@convenia/utils'
import {
  MONTH_STRING_REGEX,
  YEAR_MONTH_STRING_REGEX
} from './constants'

export const createMonthDate = (year, month) => {
  return dayjs.tz(
    `${year}-${String(month).padStart(2, '0')}-01 12:00:00`,
    'YYYY-MM-DD HH:mm:ss',
    'America/Sao_Paulo'
  ).toDate()
}

export const parseMonthDate = (value) => {
  if (!value) return null

  const date = new Date(value)

  if (Number.isNaN(date.getTime())) return null

  return createMonthDate(date.getFullYear(), date.getMonth() + 1)
}

export const parseYearMonthString = (value) => {
  const [ , year, month ] = String(value).match(YEAR_MONTH_STRING_REGEX) || []

  if (!year || !month) return null
  if (+month < 1 || +month > 12) return null

  return createMonthDate(+year, +month)
}

export const parseMonthString = (value) => {
  const [ , month, year ] = String(value).match(MONTH_STRING_REGEX) || []

  if (!month || !year) return null
  if (+month < 1 || +month > 12) return null

  return createMonthDate(+year, +month)
}

export const formatMonth = (date) => {
  const parsed = dayjs(date).tz(tz.guess())

  if (!parsed.isValid()) return ''

  return parsed.format('MM/YYYY')
}

export const normalizeInputValue = (value) => {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 6)

  if (digits.length <= 2) return digits

  return `${digits.slice(0, 2)}/${digits.slice(2)}`
}

export const compareMonth = (a, b) => {
  return dayjs(a).startOf('month').diff(dayjs(b).startOf('month'), 'month')
}

export const isSameMonth = (a, b) => {
  if (!a || !b) return false

  return dayjs(a).isSame(dayjs(b), 'month')
}
